var Blob = require('blob-polyfill').Blob;
var dragDropTouch = require("drag-drop-touch");
var FileSaver = require('file-saver');
var domtoimage = require('dom-to-image');



const cards = document.getElementsByClassName('cards-item');
const boxes = document.querySelectorAll('.box');

let draggable;
let cardio;

for(let card of cards) {
card.addEventListener('dragstart',dragStart);
card.addEventListener('dragend',dragEnd);
card.addEventListener('drop',Drop);
card.setAttribute('draggable', 'true');
}

function dragStart() {
	setTimeout(() =>(this.style.opacity = '0.5'),0);
	cardio = this;
}

function dragEnd() {
	this.style.opacity = '1';
	this.className = 'selected';
}

for(let box of boxes) {
	box.addEventListener('dragover',dragOver);
	box.addEventListener('dragenter',dragEnter);
	box.addEventListener('dragleave',dragLeave);
	box.addEventListener('drop',Drop);
}

function dragOver(e) {
	e.preventDefault();
}

function dragEnter(e) {
	e.preventDefault();
	
}

function dragLeave(e) {
	e.preventDefault();
	
}

function Drop(e) {
	e.stopPropagation();
	e.preventDefault();
	this.append(cardio);
	this.style.border = "none";
	return false;
};

var shot = document.getElementById("button");
shot.addEventListener("click", screenshot);
function screenshot(){
domtoimage.toBlob(document.getElementById('my-node'))
    .then(function (blob) {
        window.saveAs(blob, 'my-lineup.png');
    })
    };
